<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link><span class="pfimg3"><i
            class="fa fa-angle-right"></i></span>
        Distribution
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span> Manage GIN
      </h6>
      <div class="container-fluid">
        <div class="navbar background_color filter-bar">
          <div class="d-flex flex-wrap align-items-center toolbar-left">
            <b-input-group size="sm" class="search-box"><b-form-input v-model="filter" type="search"
                placeholder="Search" class="bdr-rad"></b-form-input></b-input-group><span
              class="custom-breadcrumb"><b>Showing {{ filteredGins.length }} items.</b></span>
          </div>
          <router-link to="/dsales/index" class="btn btn-outline-primary btn-sm bdr-rad back-sales">Back to
            Sales</router-link>
        </div>
        <div class="card bdr-rad2 shadow p-2">
          <div class="card-body mb-5">
            <div class="d-flex justify-content-center" v-if="isLoading">
              <div class="spinner-border text-primary"></div>
            </div>
            <div v-else class="table-responsive">
              <b-table small hover show-empty class="gin-table" :items="filteredGins" :fields="fields"
                head-variant="dark"><template #cell(number)="row">{{ row.index + 1 }}</template><template
                  #cell(actions)="row">
                  <div class="dropdown">
                    <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" data-toggle="dropdown">
                      Action
                    </button>
                    <div class="dropdown-menu bdr-rad">
                      <a class="dropdown-item mouse-cursor" @click="viewItem(row.item.id)">View</a><a
                        v-if="row.item.status === 1" class="dropdown-item mouse-cursor"
                        @click="confirmGin(row.item.id)">Confirm</a><a v-if="row.item.status === 3"
                        class="dropdown-item mouse-cursor" @click="createInvoice(row.item.id)">Create Invoice</a>
                    </div>
                  </div>
                </template><template #empty>
                  <div class="text-center">
                    No GIN records found.
                  </div>
                </template></b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>
<script>
  import axios from "axios";
  import authService from "@/auth.service";
  import TopNavbar from "./../../layout/TopNavbar.vue";
  import ContentFooter from "./../../layout/ContentFooter.vue";
  export default {
    components: { TopNavbar, ContentFooter },
    data: () => ({
      token: authService.isLoggedIn(),
      filter: "",
      items: [],
      isLoading: true,
      fields: [
        { key: "number", label: "#", sortable: true },
        { key: "gin_num", label: "GIN No.", sortable: true },
        { key: "so_num", label: "SO No.", sortable: true },
        { key: "issued_to", label: "Issued To", sortable: true },
        { key: "issue_date", label: "Issue Date", sortable: true },
        { key: "status_name", label: "Status", sortable: true },
        { key: "actions", label: "Actions" },
      ],
    }),
    computed: {
      filteredGins() {
        const term = this.filter.trim().toLowerCase();
        return this.items.filter(
          (item) =>
            !term || Object.values(item).join(" ").toLowerCase().includes(term)
        );
      },
    },
    mounted() {
      this.load();
    },
    methods: {
      async load() {
        try {
          const { data } = await axios.get("/dgin/index", {
            headers: { Authorization: "Bearer " + this.token },
          });
          this.items = data.all_data || [];
        } finally {
          this.isLoading = false;
        }
      },
      viewItem(id) {
        this.$router.push("/dgin/view?id=" + id);
      },
      createInvoice(id) {
        this.$router.push("/dinvoice/create?id=" + id);
      },
      async confirmGin(id) {
        if (!window.confirm("Confirm this GIN? Inventory will be reduced."))
          return;
        await axios.post(
          "/dgin/confirm?id=" + id,
          {},
          { headers: { Authorization: "Bearer " + this.token } }
        );
        this.load();
      },
    },
  };
</script>
<style scoped>
  .background_color {
    background: #eaf6ff;
    min-height: calc(100vh - 60px);
  }

  .bdr-rad {
    border-radius: 12px;
  }

  .bdr-rad2 {
    border-radius: 15px;
  }

  .decoration {
    color: #fff !important;
    text-decoration: none;
  }

  .font1 {
    font-size: 13px !important;
  }

  .manage-boder {
    background: #087df5;
    color: #fff;
    padding: 10px 15px !important;
    margin: 0 !important;
    line-height: normal;
  }

  .filter-bar {
    border: 0;
    padding: 2px 0 !important;
    margin: 0 !important;
    min-height: 0;
    height: 40px;
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }

  .toolbar-left {
    display: flex !important;
    flex: 1 1 auto;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    align-items: center;
    gap: 8px;
  }

  .search-box {
    flex: 0 0 205px;
    max-width: 205px;
  }

  .custom-breadcrumb {
    white-space: nowrap;
    margin-top: 11px;
  }

  .back-sales {
    flex: 0 0 auto;
    margin-left: auto;
  }

  .filter-bar+.card {
    margin-top: 0 !important;
  }

  .mouse-cursor {
    cursor: pointer;
  }

  .gap-2 {
    gap: 8px;
  }

  @media (max-width: 576px) {
    .filter-bar {
      overflow-x: auto;
    }
  }

  .gin-table {
    font-size: small;
  }
</style>
